export default __webpack_public_path__ + "static/media/video.332a6031.mp4";